import React from 'react';

type Props = {
  type?: string | null;
  style?: object;
};

const PROFILE_ICONS: { [s: string]: string } = {
  CHQ: 'ach2@2x.png',
  SAV: 'ach2@2x.png',
  VISA: 'visa@2x.png',
  VISA_DEBIT: 'visa@2x.png',
  MC: 'mastercard@2x.png',
  MC_DEBIT: 'mastercard@2x.png',
  DISC: 'discover@2x.png',
  DISC_DEBIT: 'discover@2x.png',
  AMEX: 'amex@2x.png',
  PAYPAL_ACCOUNT: 'paypal@2x.png',
  PAYPAL_CREDIT: 'paypal@2x.png',
  GP: 'google_pay@2x.png',
  AP: 'apple_pay@2x.png',
  VENMO: 'venmo@2x.png'
};

export default ({ type, style = {} }: Props) => {
  return PROFILE_ICONS[type || ''] ? (
    <img
      style={{
        width: 'auto',
        height: 'auto',
        maxHeight: '2em',
        maxWidth: '4em',
        ...style,
      }}
      src={require(`../../../images/${PROFILE_ICONS[type || '']}`)}
    />
  ) : null;
};
